<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="modePolStat === 'New'">mdi-plus</v-icon>
          <v-icon v-else-if="modePolStat === 'Review'">mdi-pencil</v-icon>
          <v-icon v-else-if="modePolStat === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newPolStat">Create New Policy Status</v-toolbar-title>
          <v-toolbar-title v-else-if="modePolStat === 'Review'">Edit Policy Status</v-toolbar-title>
          <v-toolbar-title v-else-if="modePolStat === 'Query'">Query Policy Status</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newPolStat">
                <v-text-field
                  :label="labels.polStat"
                  v-model="polStatForm.polStat"
                  :error-messages="errors.collect('polStat')"
                  data-vv-name="polStat"
                  :data-vv-as="labels.polStat"
                  v-validate="'required|param|max:2'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.polStat }}</v-subheader>
                <div class="queryValue">{{ polStatForm.polStat }}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="modePolStat === 'Query'"
                  :label="labels.polStatDesc"
                  v-model="polStatForm.polStatDesc"
                  :error-messages="errors.collect('polStatDesc')"
                  data-vv-name="polStatDesc"
                  :data-vv-as="labels.polStatDesc"
                  v-validate="'required|entry|max:20'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.perRen"
                  v-model="polStatForm.perRen"
                  :error-messages="errors.collect('perRen')"
                  data-vv-name="perRen"
                  :data-vv-as="labels.perRen"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.perNewRen"
                  v-model="polStatForm.perNewRen"
                  :error-messages="errors.collect('perNewRen')"
                  data-vv-name="perNewRen"
                  :data-vv-as="labels.perNewRen"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.perAuto"
                  v-model="polStatForm.perAuto"
                  :error-messages="errors.collect('perAuto')"
                  data-vv-name="perAuto"
                  :data-vv-as="labels.perAuto"
                  :disabled="['CA', 'RE'].includes(polStat)"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.ren23yrCvr"
                  v-model="polStatForm.ren23yrCvr"
                  :error-messages="errors.collect('ren23yrCvr')"
                  data-vv-name="ren23yrCvr"
                  :data-vv-as="labels.ren23yrCvr"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.perPol"
                  v-model="polStatForm.perPol"
                  :error-messages="errors.collect('perPol')"
                  data-vv-name="perPol"
                  :data-vv-as="labels.perPol"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.perQtn"
                  v-model="polStatForm.perQtn"
                  :error-messages="errors.collect('perQtn')"
                  data-vv-name="perQtn"
                  :data-vv-as="labels.perQtn"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.perCn"
                  v-model="polStatForm.perCn"
                  :error-messages="errors.collect('perCn')"
                  data-vv-name="perCn"
                  :data-vv-as="labels.perCn"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.defRen"
                  v-model="polStatForm.defRen"
                  :error-messages="errors.collect('defRen')"
                  data-vv-name="defRen"
                  :data-vv-as="labels.defRen"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-autocomplete
                  :readonly="modePolStat === 'Query'"
                  :items="autoExtendList"
                  v-model="polStatForm.autoExtd"
                  :label="labels.autoExtd"
                  item-text="label"
                  item-value="value"
                  data-vv-name="autoExtd"
                  :data-vv-as="labels.autoExtd"
                  :error-messages="errors.collect('autoExtd')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :readonly="modePolStat === 'Query'"
                  :label="labels.perZeroPrem"
                  v-model="polStatForm.perZeroPrem"
                  :error-messages="errors.collect('perZeroPrem')"
                  data-vv-name="perZeroPrem"
                  :data-vv-as="labels.perZeroPrem"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ polStatForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ polStatForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newPolStat">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ polStatForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ polStatForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
            <span>Cancel</span>
            <v-icon right dark>mdi-cancel</v-icon>
          </v-btn>
          <v-btn color="primary" v-if="modePolStat !== 'Query'" dark @click="doSave" :loading="submitting">
            Save Policy Status
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        polStat: 'Policy Status',
        polStatDesc: 'Description',
        perRen: 'Permit Renewal',
        perNewRen: 'Permit on New/Renewal',
        perAuto: 'Permit Auto Entry Only',
        ren23yrCvr: 'Renew 2 or 3 Year Cover Period',
        perPol: 'Permit on Policy',
        perQtn: 'Permit on Quotation',
        perCn: 'Permit on Cover Note',
        defRen: 'Default on Renewal',
        autoExtd: 'Auto Extend',
        extBefExp: 'Days to extend before Expiry',
        perZeroPrem: 'Permit Zero Premium',
        extdMonDays: 'Extend Before Expiry Days/Month',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      polStatForm: {
        polStat: null,
        polStatDesc: null,
        perRen: null,
        perNewRen: null,
        perAuto: null,
        ren23yrCvr: null,
        perPol: null,
        perQtn: null,
        perCn: null,
        defRen: null,
        autoExtd: 'Y',
        extBefExp: null,
        perZeroPrem: null,
        extdMonDays: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      submitting: false,
      autoExtendList: [
        { label: 'M - Monthly', value: 'M' },
        { label: 'Y - Yearly', value: 'Y' },
        { label: 'Never', value: '' }
      ],
      first: true
    }
  },
  methods: {
    async doInit() {
      if (!this.newPolStat) {
        const apiURI = this.menu.getPolStat
        if (apiURI) {
          try {
            const expand = {
              polStat: this.polStat
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.polStatForm.polStat = data.polStat.polStat
              this.polStatForm.polStatDesc = data.polStat.polStatDesc
              this.polStatForm.perRen = data.polStat.perRen
              this.polStatForm.perNewRen = data.polStat.perNewRen
              this.polStatForm.perAuto = data.polStat.perAuto
              this.polStatForm.ren23yrCvr = data.polStat.ren23yrCvr
              this.polStatForm.perPol = data.polStat.perPol
              this.polStatForm.perQtn = data.polStat.perQtn
              this.polStatForm.perCn = data.polStat.perCn
              this.polStatForm.defRen = data.polStat.defRen
              this.polStatForm.autoExtd = data.polStat.autoExtd
              this.polStatForm.extBefExp = data.polStat.extBefExp
              this.polStatForm.perZeroPrem = data.polStat.perZeroPrem
              this.polStatForm.extdMonDays = data.polStat.extdMonDays
              this.polStatForm.createdBy = data.createdBy
              this.polStatForm.createdDate = data.createdDate
              this.polStatForm.modifiedBy = data.modifiedBy
              this.polStatForm.modifiedDate = data.modifiedDate
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.polStatForm.polStat = null
        this.polStatForm.polStatDesc = null
        this.polStatForm.perRen = false
        this.polStatForm.perNewRen = false
        this.polStatForm.perAuto = false
        this.polStatForm.ren23yrCvr = false
        this.polStatForm.perPol = true
        this.polStatForm.perQtn = false
        this.polStatForm.perCn = false
        this.polStatForm.defRen = true
        this.polStatForm.autoExtd = ''
        this.polStatForm.extBefExp = 0
        this.polStatForm.perZeroPrem = false
        this.polStatForm.extdMonDays = false
        this.polStatForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.polStatForm.createdDate = new Date()
      }
    },
    async doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          const config = {
            method: this.newPolStat ? 'post' : 'put',
            url: this.newPolStat ? this.menu.createPolStat : this.menu.updatePolStat,
            data: this.polStatForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.doCancel()
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'polStat' })
    }
  },
  computed: {
    menu() {
      return this.$store.state.polStatParam.menu
    },
    newPolStat() {
      return this.polStat === 'new'
    },
    modePolStat() {
      return this.$route.params.modePolStat
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [MessageMixin],
  props: ['polStat']
}
</script>

<style>
</style>
